import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=784547d6&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=ts&setup=true"
export * from "./Notification.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Notification.vue?vue&type=style&index=0&id=784547d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784547d6",
  null
  
)

export default component.exports